var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isKp
    ? _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loginLoading,
              expression: "loginLoading",
            },
          ],
          staticClass: "login-wrap",
        },
        [
          _c("v-header"),
          _c(
            "div",
            { staticClass: "login-top", class: { "bg-white": !_vm.isKp } },
            [
              _vm.isKp
                ? _c("ContentLeft")
                : _c("div", { staticClass: "client-left-container" }, [
                    _c("div", { staticClass: "imglogo" }, [
                      _c("img", {
                        attrs: { src: require("@/assets/img/clara.png") },
                      }),
                    ]),
                  ]),
              _c(
                "div",
                {
                  staticClass: "client-content border-normal",
                  style: { width: !_vm.isKp ? "80%" : "70%" },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "search" },
                    [
                      _c(
                        "el-form",
                        { attrs: { inline: "", size: "medium" } },
                        [
                          _c(
                            "div",
                            { staticClass: "mb-10" },
                            [
                              _c("GuidanceTooltip", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.getUser.userType == "1",
                                    expression: "getUser.userType == '1'",
                                  },
                                ],
                                attrs: {
                                  size: 20,
                                  content: _vm.$t("businesshome_tip"),
                                  jumpLink: _vm.$t("businesshome_tip_link"),
                                },
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("please_select_visible_site")) +
                                  "\n                    "
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-cls",
                                  attrs: {
                                    "collapse-tags": "",
                                    multiple: "",
                                    clearable: "",
                                  },
                                  on: {
                                    "visible-change": (e) => {
                                      !e ? _vm.saveSiteFilter() : ""
                                    },
                                    clear: _vm.saveSiteFilter,
                                    "remove-tag": _vm.saveSiteFilter,
                                    change: _vm.onSelectChange,
                                  },
                                  model: {
                                    value: _vm.filterSite,
                                    callback: function ($$v) {
                                      _vm.filterSite = $$v
                                    },
                                    expression: "filterSite",
                                  },
                                },
                                _vm._l(_vm.siteOptions, function (v, k) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: k,
                                      attrs: {
                                        value: v.siteId,
                                        label: v.siteName,
                                      },
                                    },
                                    [
                                      [-1, -2].includes(v.siteId)
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                float: "right",
                                                "font-weight": "700",
                                                "font-size": "14px",
                                              },
                                            },
                                            [_vm._v(_vm._s(v.siteName))]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                float: "left",
                                                "font-size": "14px",
                                              },
                                            },
                                            [_vm._v(_vm._s(v.siteName))]
                                          ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "client-search",
                                  attrs: {
                                    placeholder: _vm.$t("ENTER_SEARCH_CONTENT"),
                                    maxlength: "100",
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.searchSite.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.searchKey,
                                    callback: function ($$v) {
                                      _vm.searchKey = $$v
                                    },
                                    expression: "searchKey",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.searchSite },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("ContentTopRight", { attrs: { isKp: _vm.isKp } }),
                    ],
                    1
                  ),
                  _vm.hasPrev
                    ? _c("i", {
                        staticClass: "el-icon-arrow-left switch left",
                        on: { click: _vm.prev },
                      })
                    : _vm._e(),
                  _vm.hasNext
                    ? _c("i", {
                        staticClass: "el-icon-arrow-right switch right",
                        on: { click: _vm.next },
                      })
                    : _vm._e(),
                  _c(
                    "el-row",
                    { staticClass: "client-item" },
                    [
                      _vm._l(_vm.siteList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: item.siteId,
                            class: [
                              "item",
                              item.rollForWardFlag ? "site-rollFordWard" : "",
                              item.isSiteAdmin
                                ? "site-isAdmin"
                                : "not-site-isAdmin",
                              !_vm.isKp ? "client-width-client" : "",
                            ],
                          },
                          [
                            item.ifTestSite
                              ? _c("img", {
                                  staticClass: "test-site-watermark",
                                  attrs: {
                                    src: require("@/assets/img/demo_site.svg"),
                                  },
                                })
                              : _vm._e(),
                            _vm.getUser.userType === "2"
                              ? _c("div", { staticClass: "siteItem" }, [
                                  _c("div", { staticClass: "whole" }, [
                                    _c("div", { staticClass: "tName" }, [
                                      _c("span", [
                                        _vm._v(_vm._s(item.clientName)),
                                      ]),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "bName",
                                        on: {
                                          click: function ($event) {
                                            return _vm.goToClient(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(item.siteName)),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "set-icon flex" },
                                    [
                                      _c("img", {
                                        staticClass: "pin-normal mr-10",
                                        attrs: {
                                          src: !item.ifPin
                                            ? _vm.notPinIcon
                                            : _vm.pinedIcon,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.updatePinStatus(item)
                                          },
                                        },
                                      }),
                                      _c("img", {
                                        staticClass: "pin-hover mr-10",
                                        attrs: {
                                          src: !item.ifPin
                                            ? _vm.notPinIconHover
                                            : _vm.pinedIconHover,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.updatePinStatus(item)
                                          },
                                        },
                                      }),
                                      item.isSiteAdmin
                                        ? [
                                            item.rollForWardFlag
                                              ? _c("img", {
                                                  staticClass: "item-i",
                                                  attrs: {
                                                    src: require("@/assets/img/icon-setting3.svg"),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.goToSetting(
                                                        item
                                                      )
                                                    },
                                                  },
                                                })
                                              : _c("img", {
                                                  staticClass: "item-i",
                                                  attrs: {
                                                    src: require("@/assets/img/icon-setting.svg"),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.goToSetting(
                                                        item
                                                      )
                                                    },
                                                  },
                                                }),
                                            _c("img", {
                                              staticClass: "item-i2",
                                              attrs: {
                                                src: require("@/assets/img/icon-setting2.svg"),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goToSetting(item)
                                                },
                                              },
                                            }),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ])
                              : _c(
                                  "el-popover",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      width: "100%",
                                      height: "100%",
                                    },
                                    attrs: {
                                      placement: "bottom",
                                      "popper-class": "scale-popper-cls",
                                      trigger: "hover",
                                      "open-delay": 1500,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "engagement-info" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "engagement-item engagement-item-sitecode",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(_vm.$t("site_code")) +
                                                ": "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "value" },
                                              [_vm._v(_vm._s(item.siteCode))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "engagement-item" },
                                          [
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  trigger: "hover",
                                                  "open-delay": 1500,
                                                  placement: "right",
                                                  "popper-class":
                                                    "engagement-info-popover",
                                                  content:
                                                    _vm.$t("team_member"),
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "el-col-auto margin-right-30",
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "el-col-auto engagement-item-icon",
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass:
                                                            "kp-user",
                                                          attrs: {
                                                            src: require("@/assets/img/icon-kpuser.svg"),
                                                            width: "100%",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "engagement-item-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.statisticData
                                                              ? item
                                                                  .statisticData
                                                                  .kpTeamMemberCount
                                                              : null
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "engagement-item-unit",
                                                      },
                                                      [_vm._v(" ppl")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  trigger: "hover",
                                                  "open-delay": 1500,
                                                  placement: "right",
                                                  "popper-class":
                                                    "engagement-info-popover",
                                                  content:
                                                    _vm.$t("client_user"),
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "el-col-auto",
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "el-col-auto engagement-item-icon",
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass:
                                                            "client-user",
                                                          attrs: {
                                                            src: require("@/assets/img/icon-clientuser.svg"),
                                                            width: "100%",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "engagement-item-value client",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.statisticData
                                                              ? item
                                                                  .statisticData
                                                                  .invitedClientUserCount
                                                              : ""
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "engagement-item-unit",
                                                      },
                                                      [_vm._v(" ppl")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "engagement-item" },
                                          [
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  trigger: "hover",
                                                  "open-delay": 800,
                                                  placement: "right",
                                                  "popper-class":
                                                    "engagement-info-popover",
                                                  content:
                                                    _vm.$t("file_upload_size"),
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "el-col-auto margin-right-30",
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "el-col-auto engagement-item-icon",
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass:
                                                            "green-bdg",
                                                          attrs: {
                                                            src: require("@/assets/img/icon-upload-green.svg"),
                                                            width: "100%",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "engagement-item-value green",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.statisticData
                                                              .existFileTotalSize
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  trigger: "hover",
                                                  "open-delay": 1500,
                                                  placement: "right",
                                                  "popper-class":
                                                    "engagement-info-popover",
                                                  content:
                                                    _vm.$t(
                                                      "file_upload_number"
                                                    ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "el-col-auto",
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "el-col-auto engagement-item-icon",
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass:
                                                            "green-bdg",
                                                          attrs: {
                                                            src: require("@/assets/img/icon-upload-green.svg"),
                                                            width: "100%",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "engagement-item-value green",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.statisticData
                                                              .existFileCount
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "engagement-item-unit",
                                                      },
                                                      [_vm._v(" PCS")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "engagement-item no-border",
                                          },
                                          [
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  trigger: "hover",
                                                  "open-delay": 1500,
                                                  placement: "right",
                                                  "popper-class":
                                                    "engagement-info-popover",
                                                  content:
                                                    _vm.$t(
                                                      "file_download_size"
                                                    ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "el-col-auto margin-right-30",
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "el-col-auto engagement-item-icon",
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass:
                                                            "kp-user",
                                                          attrs: {
                                                            src: require("@/assets/img/icon-download-blue.svg"),
                                                            width: "100%",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "engagement-item-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.statisticData
                                                              .downloadFileTotalSize
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  trigger: "hover",
                                                  "open-delay": 1500,
                                                  placement: "right",
                                                  "popper-class":
                                                    "engagement-info-popover",
                                                  content: _vm.$t(
                                                    "file_download_number"
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "el-col-auto",
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "el-col-auto engagement-item-icon",
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass:
                                                            "kp-user",
                                                          attrs: {
                                                            src: require("@/assets/img/icon-download-blue.svg"),
                                                            width: "100%",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "engagement-item-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.statisticData
                                                              .downloadFileCount
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "engagement-item-unit",
                                                      },
                                                      [_vm._v(" PCS / ")]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "engagement-item-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.statisticData
                                                              .downloadCount
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "engagement-item-unit",
                                                      },
                                                      [_vm._v(" Times")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "siteItem",
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "site-status",
                                            class: [
                                              item.siteUsageStatus,
                                              item.ifTestSite
                                                ? "test-flag"
                                                : "",
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  item.ifTestSite
                                                    ? _vm.$t("demo_site")
                                                    : _vm.$t(
                                                        `businesshome_codestatus_${item.siteUsageStatus}`
                                                      )
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                        _c("div", { staticClass: "whole" }, [
                                          _c("div", { staticClass: "tName" }, [
                                            _c("span", [
                                              _vm._v(_vm._s(item.clientName)),
                                            ]),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "bName",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goToClient(item)
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(item.siteName)),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "set-icon flex" },
                                          [
                                            _c("img", {
                                              staticClass: "pin-normal mr-10",
                                              attrs: {
                                                src: !item.ifPin
                                                  ? _vm.notPinIcon
                                                  : _vm.pinedIcon,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.updatePinStatus(
                                                    item
                                                  )
                                                },
                                              },
                                            }),
                                            _c("img", {
                                              staticClass: "pin-hover mr-10",
                                              attrs: {
                                                src: !item.ifPin
                                                  ? _vm.notPinIconHover
                                                  : _vm.pinedIconHover,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.updatePinStatus(
                                                    item
                                                  )
                                                },
                                              },
                                            }),
                                            item.isSiteAdmin
                                              ? [
                                                  item.rollForWardFlag
                                                    ? _c("img", {
                                                        staticClass: "item-i",
                                                        attrs: {
                                                          src: require("@/assets/img/icon-setting3.svg"),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.goToSetting(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _c("img", {
                                                        staticClass: "item-i",
                                                        attrs: {
                                                          src: require("@/assets/img/icon-setting.svg"),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.goToSetting(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      }),
                                                  _c("img", {
                                                    staticClass: "item-i2",
                                                    attrs: {
                                                      src: require("@/assets/img/icon-setting2.svg"),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.goToSetting(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                          ],
                          1
                        )
                      }),
                      _vm._l(
                        _vm.pagination.pageSize - _vm.siteList.length,
                        function (index) {
                          return _c("div", {
                            key: index,
                            staticClass: "item item-empty",
                            class: { "client-width-client": !_vm.isKp },
                          })
                        }
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-bottom"),
        ],
        1
      )
    : _c("ClientUserWrap", { attrs: { "site-ids": _vm.propsFilterSite } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }